export function paModApps() {
    return {
        active: 0,

        setActive(index) {
            this.active = index;
        }
    };
}
